import { Component } from '@angular/core';
import { AbstractFormWidgetComponent } from '../../../../../../shared/components/widget/abstract-form-widget/abstract-form-widget.component';
import { ResourceService } from 'sce-core';
import { NavigationService } from '../../../../../../core/navigation.service';
import { LeftPanelService } from '../../../../../../layout/home/services/left-panel.service';
import { AlertService } from 'sce-core';
import { UserService } from '../../../../../../core/security/user.service';
import { DatePickerConfigService } from '../../../../../../shared/components/datepicker/datepicker-config.service';

@Component({
  selector: 'lfwms-work-orders-search',
  templateUrl: './work-orders-primary-accordian.component.html',
  styleUrls: ['./work-orders-primary-accordian.component.css']
})
export class  WorkOrdersPrimaryAccordianComponent extends AbstractFormWidgetComponent {

  constructor(protected resourceService: ResourceService,
    protected navService: NavigationService,
    protected leftPanelService: LeftPanelService,
    protected alertService: AlertService,
    protected userService: UserService,
    protected dateConfigService: DatePickerConfigService) {
      super(resourceService, navService, leftPanelService, alertService, userService, dateConfigService);
    }
}



// WEBPACK FOOTER //
// /var/lib/jenkins/workspace/1_SCE_CI_CD_SIT/src/app/features/inventory/work-order-management/work-order-execution/work-orders/work-orders-primary-accordian/work-orders-primary-accordian.component.ts